module.exports = __webpack_public_path__ + "img/pla_LZDMY.a563ebc8.png";